var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { DragDropAssignmentAFY, ModalAFY, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React, { useState } from "react";
import { AddPermissionToRol, ModalUiProps, } from "../../constanst/adminRolesDTO";
export var EditAddPermission = function (props) {
    var _a = useState(props.rolId), currentRoll = _a[0], setCurrentRoll = _a[1];
    var _b = useState([]), assignedPermissions = _b[0], setAssignedPermissions = _b[1];
    return (_jsx(ModalAFY, __assign({}, ModalUiProps, { title: "Asignación de Permiso: ", name: props.rolName, openModal: props.openMadalEdit, onClose: function () {
            props.setOpenModalEdit(false);
        }, onSave: function () {
            return props.handleAssignPermissions(currentRoll, assignedPermissions);
        } }, { children: _jsx(DragDropAssignmentAFY, __assign({}, AddPermissionToRol, { userId: props.rolId, assignedItems: props.assignedPermission, availableItems: props.PermissionList, onAssignmentChange: function (rol, permissions) {
                setCurrentRoll(rol);
                setAssignedPermissions(permissions);
            } })) })));
};
